// extracted by mini-css-extract-plugin
module.exports = {"selectBase":"style-module--selectBase--1bkvb","select":"style-module--select--3Nu1b","selectLight":"style-module--selectLight--mtVOP","size_big":"style-module--size_big--3NCsN"};